import React from 'react';

import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { AnchorWithLink } from 'atoms/Anchor';
import ImageComponent from 'atoms/Image';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { getTernaryValue } from 'common/utilities/utils';

const ScheduleOrderFormSectionComp = props => {
  const {
    isAlert,
    show,
    sectionHeader,
    subSectionValue,
    orderTypeChange,
    onClickHandler,
    description,
    storeUnavailableError,
    showChangeButton = true,
    scheduleTimeWarning = false,
    scheduleErrMsg = '',
  } = props;
  return show ? (
    <div className='schedule-order-form-sections'>
      <h3 className='schedule-form-subsection-header'>{translateWithI18Next(sectionHeader)}</h3>
      {Boolean(storeUnavailableError) && (
        <div className={`store-cannot-deliver-error ${getTernaryValue(!isAlert, 'store-error-msg-container', '')}`}>
          <ImageComponent
            srcFile={(isAlert && IMAGE_PATH.Error_Yellow ) || IMAGE_PATH.Error}
            className='store-cannot-deliver-icon'
          />
          <div
            className='storeErrorMessage'
            dangerouslySetInnerHTML={{ __html: translateWithI18Next(storeUnavailableError) }}
          ></div>
        </div>
      )}
      {Boolean(scheduleTimeWarning) && (
        <div className='store-cannot-schedule-error timebased-inline-message'>
          <ImageComponent srcFile={IMAGE_PATH.Error} className='store-cannot-deliver-icon' />
          <div className='storeErrorMessage'>{scheduleErrMsg}</div>
        </div>
      )}
      <div className='schedule-form-subsection'>
        <div className='schedule-order-subsection-value'>{subSectionValue}</div>
        {description && <div className='schedule-order-subsection-value flat-num'>{description}</div>}
        <div className='border-bottom' />
        {showChangeButton && (
          <div className='changeOrEditOrderType'>
            <AnchorWithLink
              aria-label='Edit order type'
              onClickHandler={onClickHandler}
              data-testid='dynamic-click-test'
            >
              {translateWithI18Next(orderTypeChange)}
            </AnchorWithLink>
          </div>
        )}
      </div>
    </div>
  ) : null;
};

const ScheduleOrderFormSection = React.memo(ScheduleOrderFormSectionComp);

export default ScheduleOrderFormSection;
